const planAutoNI: number = 555;
const planAutoHN: number = 374;
export { planAutoNI ,planAutoHN}